export let keys = {
    tab: 9,
    enter: 13,
    left: 37,
    up: 38,
    right: 39,
    down: 40
};


// WEBPACK FOOTER //
// ./src/typescript/keyboard_tools.ts